import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../../../app/services/shared/interfaces';
import ButtonCancelForm from '../../../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../../../components/buttons/ButtonSaveForm';
import useWarehouseStorageService from '../../../../../app/services/hooks/useWareHouseQuoteStorageService';
import { WarehouseQuoteStorageDataForm } from '../../../../../app/models/WareHouseQuoteStorage';
import { Depot } from '../../../../../app/models/Depot';
import WarehouseQuoteStorageForm from './forms/WareHouseStorageForms/WareHouseStorageForm';
import useReactConfirmAlert from '../../../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../../../contexts/AppContext';

interface Props {
    storageId: number;
    onSaved: () => void;
    onCancel: () => void;
}

const WarehouseQuoteStorageEdit = ({ storageId, onSaved, onCancel }: Props) => {
    const { updateWarehouseStorage, editWarehouseStorage, fetchingEditWarehouseQuoteStorage } = useWarehouseStorageService();
    const [disableUpdate, setDisableUpdate] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [warehouseStorageform, setWarehouseStorageform] = useState<WarehouseQuoteStorageDataForm>({
        quote_id: storageId,
        depot_id: undefined,
        free_days: 0
    });
    const [errorFields, setErrorFields] = useState<any>();

    const [depots, setDepots] = useState<Depot[]>([]);
    useEffect(() => {
        edit();
    }, [storageId]);

    const edit = () => {
        editWarehouseStorage(storageId, {
            onSuccess: (response: ServiceResponse) => {
                setWarehouseStorageform(response.data.warehouse_quote_storage);
                setDepots(response.data.depots);
                setDisableUpdate(true);
                setIsEdit(true);
            },
            onError: (response: ServiceResponse) => {
                toast.error('Error al cargar almacenamiento');
            }
        });
    };

    const update = () => {
        updateWarehouseStorage(storageId, warehouseStorageform, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
    
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
    
                toast.success(response.message, { autoClose: 2500 });
                setErrorFields(undefined);
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

    
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });


                toast.error(response.message);
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }
        });
    };

    return (
        <>
            <WarehouseQuoteStorageForm
                warehouseStorageform={warehouseStorageform}
                setWarehouseStorageform={setWarehouseStorageform}
                depots={depots}
                disableUpdate={disableUpdate}
                isEdit={isEdit}
                
            />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={onCancel} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} />
                </div>
            </div>
        </>
    );
};

export default WarehouseQuoteStorageEdit;
